import React from 'react';
import Icon from '../Icon'

export default function FemaleIcon({ title }) {
    return (<Icon icon="businesswoman" title={title} style={{ color: "red", fontSize: "16px", paddingRight: "4px" }} />);
};